import { Button } from 'src/components/Buttons/Button';
import { GameData } from 'react-easyrocket';
import { useModalContext } from 'src/hooks/useModalContext';
import { useTranslation } from 'react-i18next';
import { useGameHandleClick } from '../../utils/useGameHandleClick';

interface GameControlsProps {
  showAddfavorite: boolean;
  onClick?: () => void;
  isFavorite?: boolean;
  game: GameData;
  heartIconSize?: string;
}

export const GameControls = ({ game, onClick }: GameControlsProps) => {
  const { t } = useTranslation();
  const { closeModal } = useModalContext();
  const { handlePlayGameClick, handlePlayDemoGameClick } = useGameHandleClick({
    game: game,
    onClick: () => onClick?.()
  });

  return (
    <div className="flex flex-col justify-end items-center px-2.5 pb-2.5 568:pb-5 w-full h-full rounded-lg border border-solid border-gc_border absolute top-0 left-0 z-[3] bg-CARD_GAME_HOVER_BG opacity-0 transition duration-300 group-hover:opacity-100">
      <Button
        title={`${t('general.play')}`}
        mode="button-primary"
        className="!w-full !h-[30px]"
        onClick={(e) => {
          closeModal();
          handlePlayGameClick(e);
        }}>
        {t('general.play')}
      </Button>
      {game.hasDemo && (
        <Button
          onClick={handlePlayDemoGameClick}
          title={`${t('general.playDemo')}`}
          mode="button-secondary"
          className="!w-full !h-[30px] mt-1 568:mt-3">
          {t('general.playDemo')}
        </Button>
      )}
    </div>
  );
};
